export default __webpack_public_path__ + "static/media/Delzad_Bamji_Resume_2021.a32980fa.pdf";